import React from 'react';

import Button from '@atlaskit/button/new';

export default function ButtonDangerExample() {
	return <Button appearance="danger">Danger button</Button>;
}
